export default __webpack_public_path__ + "static/media/a.3fa6cb58.jpeg";